/* Far & Away "Quality Has a Price" landing page (native rebuild of the Replo page /pages/quality-has-a-price).
   1. LEARN MORE scrolls smoothly to the comparison table that is visible at the current width (the Replo button
      targeted the desktop table only, which is display:none up to 1024px, so it did nothing on phones and tablets).
   2. Cheap-tableware "Total 5-year cost" for every presentment currency other than the store currency (on the EU
      store: GBP, USD, CHF, CZK, DKK, HUF, PLN, SEK; the US store sells in USD only): the store-currency base (data-fq-cheap-base) converted at Shopify.currency.rate, rounded down to the nearest
      10 (the figure is a lower bound, the "+" stays in the markup), formatted like the shop's money format for
      the active currency (learned from data-fq-money-sample = {{ 123456 | money }}). The same conversion rule as
      the bundles page delivery thresholds (assets/fa-lp.js initDelivery). Hooks: data-fq-*. */
(function () {
  'use strict';
  function all(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }

  function visible(el) { return !!el && el.getClientRects().length > 0 && getComputedStyle(el).display !== 'none'; }
  function initScroll() {
    all('[data-fq-scroll]').forEach(function (btn) {
      if (btn.__fq) return; btn.__fq = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var targets = [document.getElementById(btn.getAttribute('data-fq-scroll'))].concat(all('.fa-qhp-130t107'));
        var t = targets.filter(visible)[0];
        if (!t) return;
        // scrollIntoView rather than window.scrollTo: the US theme scrolls <body>, not the document
        t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function moneyFormatter(sample) {
    // sample is 1234.56 in the active currency's money format, e.g. "€1.234,56", "£1,234.56", "1.234,56 zł",
    // "1 234,56 kr", or without decimals for zero-decimal formats ("1.235 Ft")
    var m = /^([^0-9]*)1([^0-9]?)23(?:4[^0-9]56|5)([^0-9]*)$/.exec(String(sample || '').trim());
    if (!m) return null;
    return function (v) {
      var s = String(Math.round(v));
      if (m[2]) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, m[2]);
      return m[1] + s + m[3];
    };
  }
  function initCurrency() {
    var cur = window.Shopify && window.Shopify.currency;
    var rate = cur ? parseFloat(cur.rate) : NaN;
    if (!cur || !cur.active || !(rate > 0)) return;
    all('[data-fq-convert]').forEach(function (section) {
      var base = parseFloat(section.getAttribute('data-fq-cheap-base'));
      if (!(base > 0)) return;
      var fmt = moneyFormatter(section.getAttribute('data-fq-money-sample'));
      var symbols = { CHF: 'CHF ', CZK: 'Kč ', DKK: 'kr ', HUF: 'Ft ', PLN: 'zł ', SEK: 'kr ', USD: '$', EUR: '€', GBP: '£' };
      var v = Math.floor(base * rate / 10) * 10;
      var text = fmt ? fmt(v) : (symbols[cur.active] || cur.active + ' ') + v;
      all('[data-fq-cheap]', section).forEach(function (el) { el.textContent = text; });
    });
  }

  function init() { initScroll(); initCurrency(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
